/**
 * Compiled-in default platform URLs for the CLI.
 *
 * Single source of truth — every command's final `??` fallback resolves here,
 * so the prod default lives in exactly one place. Runtime overrides still win
 * (`--api-url` / `--app-url` flags, `CANARY_API_URL` / `COFACTOR_API_URL` env,
 * `--env`, and stored profile). Both the `canary` and `cofactor` brands share
 * this default; `trycanary.ai` 301-redirects to `runcofactor.com`, so the old
 * host keeps working for anyone with it saved.
 */
export const DEFAULT_API_URL = 'https://api.runcofactor.com';
export const DEFAULT_APP_URL = 'https://app.runcofactor.com';
